"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SanctionTrueHitsHandlingOtherDescription = void 0;
const Field_type_1 = require("../../../types/Field.type");
exports.SanctionTrueHitsHandlingOtherDescription = {
    priority: 2,
    label: 'fields.payload.mor_group_answers.sanction_true_hits_handling_other_description.label',
    fallbackLabel: 'Please provide your rationale as to why any of these sanctions controls are not performed and how you mitigate the risk associated. If you perform all the above steps, write \'N/A\'.',
    mandatory: (payload, path) => isMandatory(payload, path),
    disabled: (payload, path) => false,
    applicable: (payload, path) => isApplicable(payload, path),
    applicableDependsOn: ['contract_onboarding_type'],
    type: Field_type_1.FieldType.String,
    trackFieldValueWithAnalytics: false,
};
function isMandatory(payload, path) {
    return (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_GROUP');
}
function isApplicable(payload, path) {
    return (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_GROUP');
}
